import React from "react";
import Text from "./Text.react";

export default class ParaBlock extends React.Component {
    render() {
        // let isPortrait =
        //     this.props.mobileView || window.innerHeight > window.innerWidth;
        let componentStyles = {
            default: {
                background: `${this.props.colors.base}cc`,
                padding: "15px",
                fontSize: "1.1em",
            },
            grid: {},
        };

        return (
            <div style={componentStyles[this.props.layout]}>
                <Text
                    keyName={"question-" + this.props.slideId}
                    text={this.props.data.paragraph}
                    color={this.props.colors.baseText}
                    fontSize="large"
                    animation="fadeIn,100"
                />
            </div>
        );
    }
}
